import ListItem from 'elements/ListItem';
import ds from 'designsystem';

/* Disable ESlint rules for this file */
/* eslint no-confusing-arrow: "off" */
/* eslint react/destructuring-assignment: "off" */

const TitleText = ListItem.extend`
    display:flex;
    justify-content:space-between;
    font-size: ${props => props.isActive ? ds.fs('l') : ds.fs('m')}
`;

export default TitleText;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/PanelGroup/TitleText.jsx